import { jsx as _jsx } from "react/jsx-runtime";
import { SocialsAiInstructionsItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = ({ isEditing, isSaveLoading, item, onCancel, onDelete, onEdit, onSave }) => (_jsx(SocialsAiInstructionsItem, { isEditing: isEditing, isSaveLoading: isSaveLoading, item: item, onCancel: onCancel, onDelete: onDelete, onEdit: onEdit, onSave: onSave }));
export default Item;
